import type { ArticleNames } from "../../../../utils/articles";
import { getArticleByName } from "../../../../utils/articles";

export const getNeededRelocationDaysCount = (article: ArticleNames): number => {
  const articleByName = getArticleByName(article);
  return articleByName.timeRange.max;
};
